// extracted by mini-css-extract-plugin
module.exports = {"header":"aI2iQF-oz7cSmqNGuiM0L","itemJustifyEnd":"_3wmLngVC1QzWoohXe1zwzv","notifications":"ED7bhthjYsA6aPIn_jqp4","notificationsAmount":"_3Yut94z8Wvv6Xjjfksl4lX"};